module.exports = __webpack_public_path__ + "img/car_park.c1b3f5de.jpg";